import { render, staticRenderFns } from "./preventivno-odrzavanje.editor.vue?vue&type=template&id=59981040&scoped=true&"
import script from "./preventivno-odrzavanje.editor.vue?vue&type=script&lang=ts&"
export * from "./preventivno-odrzavanje.editor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59981040",
  null
  
)

export default component.exports